import ride from "./ride.component";
import rideUrls from "./ride.urls";
import RideTransforms from "./ride.transforms";
import RideBackupsTransform from "./rideBackups.transforms";

const rideModule = angular
  .module("app.components.ride", [])
  .component("ridePage", ride)
  .service("RideTransforms", RideTransforms)
  .service("RideBackupsTransform", RideBackupsTransform)
  .config(rideUrls);

export default rideModule;



// WEBPACK FOOTER //
// ./src/pages/ride/ride.module.js